import { ICellRendererParams } from '@ag-grid-community/core';
import { ReactElement } from 'react';
import { WindowsUpdate } from '../../models/windows-update';
import NullValueCellRenderer from './NullValueCellRenderer';
import { CellText } from '../../../patch-view/core/chameleon-cell-renderers/CellText';

function CategoriesCellRenderer(props: ICellRendererParams<WindowsUpdate, string[]>): ReactElement | null {
  const categories = props.getValue ? props.getValue() : null;
  if (categories === null || categories.length === 0) return <NullValueCellRenderer />;
  return (
    <CellText>
      {categories.map((c: string, index: number) =>
        c ? (
          <span key={c}>
            {c}
            {index !== categories.length - 1 && ', '}
          </span>
        ) : (
          ''
        )
      )}
    </CellText>
  );
}

export default CategoriesCellRenderer;
